// Constants
import { SIGNING_PROVIDER } from "../../../constants/SigningProviderConstants";

// Helpers
import { isVWAGGroup } from "../../../helpers/utils";

const initialState = {};

const pluginReducer = (state, action) => {
  if (typeof state === "undefined") {
    state = initialState;
  }
  switch (action.type) {
    case "GET_PLUGINS_BY_CATEGORY_SUCCESS":
      return Object.assign(
        {},
        { pluginsByCategory: action.resp.data?.providers }
      );
    case "GET_PLUGINS_DETAILS_SUCCESS":
      return Object.assign({}, { pluginDetails: action.resp.data });
    case "UPDATE_PLUGIN_CUSTOMER_PREVIEW_DETAILS_SUCCESS":
      return Object.assign(
        {},
        {
          ...state,
          pluginDetails: {
            ...state.pluginDetails,
            preview: action.resp,
          },
        }
      );
    case "UPDATE_PLUGIN_DETAILS_BY_STATUS_SUCCESS":
      return Object.assign(
        {},
        {
          ...state,
          // Feature update for list view commented out for now
          pluginsByCategory: state.pluginsByCategory.map((plugin) =>
            plugin.providerId === action.payload
              ? { ...plugin, enabled: !plugin.enabled }
              : plugin
          ),
          // pluginDetails: {
          //   ...state.pluginDetails,
          //   enabled: !state.pluginDetails.enabled,
          // },
        }
      );

    case "GET_QES_PROVIDERS_SUCCESS":
      return Object.assign(
        {},
        {
          qesProviders: isVWAGGroup()
            ? action.resp.data.providers.filter(
                (provider) => provider.providerId === SIGNING_PROVIDER.VERIMI
              )
            : action.resp.data.providers,
        }
      );

    default:
      return state;
  }
};

export default pluginReducer;
